<template>
  <filter-wrapper @submit="submit">
    <div class="filter-flex">
      <div class="filter__row">
        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('autocaller_v2.stats.filter.campaign_name') }}
          </label>
          <div class="filter__item__body">
            <select-id v-model="form.campaign_id" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('autocaller_v2.stats.filter.src') }}
          </label>
          <div class="filter__item__body">
            <i-input v-model="form.src" :clearable="true" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('autocaller_v2.stats.filter.dst') }}
          </label>
          <div class="filter__item__body">
            <i-input v-model="form.dst" :clearable="true" />
          </div>
        </div>
      </div>

      <div class="filter__row">
        <select-state v-model="form.state" class="col-3" />
        <div class="filter__item filter__item--datepicker col-6">
          <label class="filter__item__title">
            {{ $t('shared.component.filter.period') }}
          </label>
          <div class="filter__item__body">
            <date-range-picker v-model="form.date_start" />
          </div>
        </div>

        <div class="filter__row ml-auto">
          <div class="filter__item filter__item--button">
            <i-button html-type="submit" type="primary">
              {{ $t('shared.component.filter.show_result') }}
            </i-button>
          </div>
          <div class="filter__item filter__item--button">
            <i-button type="primary" icon="md-arrow-up" @click="make_export">
              {{ $t('db.recipient.button.export') }}
            </i-button>
          </div>
        </div>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import SelectState from './campaigns-filter-state';
  import SelectId from './campaigns-filter-id';
  import { mapActions, mapGetters } from 'vuex';
  import { parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import { StatsService } from '@autocaller_v2/services/StatsService';

  export default {
    components: {
      FilterWrapper,
      SelectState,
      SelectId
    },
    data: () => ({
      form: {
        campaign_id: null,
        number: '',
        src: '',
        dst: '',
        state: null,
        date_start: null
      }
    }),

    computed: {
      ...mapGetters('autocaller_v2/stats/details/table', ['filter'])
    },

    mounted() {
      this.submit();
    },

    methods: {
      ...mapActions('autocaller_v2/stats/details/table', ['search']),

      submit() {
        const { start, end } = parseSearchStateByPeriod(this.form.date_start);
        const { number, src, dst, state, campaign_id } = this.form;

        const params = {
          number,
          src,
          dst,
          state,
          campaign_id,
          date_start_from: start,
          date_start_to: end
        };

        this.search(params);
      },
      make_export() {
        const { start, end } = parseSearchStateByPeriod(this.form.date_start);
        const { number, src, dst, state, campaign_id } = this.form;

        const params = {
          number,
          src,
          dst,
          state,
          campaign_id,
          date_start_from: start,
          date_start_to: end
        };

        StatsService.export(params)
          .then(() => {
            this.$noty.success(this.$t('shared.component.noty.export_pbx'));
          })
          .catch((error) => this.$noty.server_error(error));
      }
    }
  };
</script>
